import { render, staticRenderFns } from "./BrandStory.vue?vue&type=template&id=be971d72&scoped=true&"
import script from "./BrandStory.vue?vue&type=script&lang=js&"
export * from "./BrandStory.vue?vue&type=script&lang=js&"
import style0 from "./BrandStory.vue?vue&type=style&index=0&id=be971d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be971d72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
